<template>
  <div id="app" :class="{ 'export-mode': isExport }">
    <!-- Header -->
    <div v-if="!isExport" class="site-header">
      <img src="@/assets/arts/cabanedj.svg" class="art-header" alt="" aria-hidden="true">
      <a href="/" class="logo-link">
        <img :src="require('@/assets/logotop.svg')" alt="Le Cabanon Annecy" class="site-logo">
      </a>
      <a class="insta-header" href="https://www.instagram.com/lecabanon.annecy/" target="_blank" rel="noopener noreferrer">
        <svg class="insta-header-logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 157.1 25.8">
          <path fill="#0c0c0b" d="M21.2,6c0,.9-.7,1.5-1.5,1.5s-1.5-.7-1.5-1.5.7-1.5,1.5-1.5,1.5.7,1.5,1.5M12.8,17.1c-2.4,0-4.3-1.9-4.3-4.3s1.9-4.3,4.3-4.3,4.3,1.9,4.3,4.3-1.9,4.3-4.3,4.3M12.8,6.2c-3.6,0-6.6,2.9-6.6,6.6s2.9,6.6,6.6,6.6,6.6-3,6.6-6.6-3-6.6-6.6-6.6M12.8,0C9.3,0,8.9,0,7.5,0c-1.4,0-2.3.3-3.1.6-.8.3-1.6.8-2.3,1.5-.7.7-1.2,1.4-1.5,2.3-.3.8-.5,1.7-.6,3.1C0,8.9,0,9.3,0,12.8s0,3.9,0,5.3c0,1.4.3,2.3.6,3.1.3.8.8,1.6,1.5,2.3.7.7,1.4,1.2,2.3,1.5.8.3,1.7.5,3.1.6,1.4,0,1.8,0,5.3,0s3.9,0,5.3,0c1.4,0,2.3-.3,3.1-.6.8-.3,1.6-.8,2.3-1.5.7-.7,1.2-1.4,1.5-2.3.3-.8.5-1.7.6-3.1,0-1.4,0-1.8,0-5.3s0-3.9,0-5.3c0-1.4-.3-2.3-.6-3.1-.3-.8-.8-1.6-1.5-2.3-.7-.7-1.4-1.2-2.3-1.5-.8-.3-1.7-.5-3.1-.6C16.8,0,16.3,0,12.8,0M12.8,2.3c3.4,0,3.8,0,5.2,0,1.3,0,1.9.3,2.4.4.6.2,1,.5,1.5,1,.4.4.7.9,1,1.5.2.5.4,1.1.4,2.4,0,1.4,0,1.8,0,5.2s0,3.8,0,5.2c0,1.3-.3,1.9-.4,2.4-.2.6-.5,1-1,1.5-.4.4-.9.7-1.5,1-.5.2-1.1.4-2.4.4-1.4,0-1.8,0-5.2,0s-3.8,0-5.2,0c-1.3,0-1.9-.3-2.4-.4-.6-.2-1-.5-1.5-1-.4-.4-.7-.9-1-1.5-.2-.5-.4-1.1-.4-2.4,0-1.4,0-1.8,0-5.2s0-3.8,0-5.2c0-1.3.3-1.9.4-2.4.2-.6.5-1,1-1.5.4-.4.9-.7,1.5-1,.5-.2,1.1-.4,2.4-.4,1.4,0,1.8,0,5.2,0"/>
          <text fill="#231f20" font-family="Montserrat, sans-serif" font-style="italic" font-size="9" x="29.1" y="11.2">Planning &amp; événements</text>
          <text fill="#231f20" font-family="Montserrat, sans-serif" font-weight="700" font-size="10" x="29.1" y="23.2">@lecabanon.annecy</text>
        </svg>
      </a>
    </div>

    <router-view />

    <!-- Footer -->
    <footer v-if="!isExport" class="footer">
      <img src="@/assets/arts/boules.svg" class="art-footer art-footer-left" alt="" aria-hidden="true">
      <img src="@/assets/arts/lightsbottom.svg" class="art-footer art-footer-right" alt="" aria-hidden="true">
      <div class="container text-center footer-content">
        <span class="neonText footer-title">Le Cabanon</span><br>
        <p class="footer-link">
          <a href="http://www.lecabanonannecy.fr" target="_blank" rel="noopener noreferrer">www.lecabanonannecy.fr</a> |
          © 2023-2026 Tous droits réservés. | Propulsé par <a href="https://www.thecompagnie.eu" target="_blank" rel="noopener noreferrer">www.TheCompagnie.eu</a>
        </p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App',
  computed: {
    isExport() {
      return this.$route.query.export === 'true' || this.$route.query.export === '1';
    }
  }
}
</script>
<style>
  
/* Tablette */
@media (max-width: 1024px) {
  .site-header {
    padding: 20px 15px 15px;
  }
  .site-logo {
    width: 350px;
  }
  .insta-header {
    right: 15px;
  }
  .insta-header-logo {
    width: 140px;
  }
  .art-header {
    width: 600px;
    top: -120px;
    left: -80px;
  }
  .introtext h2.titreintro {
    font-size: 3rem !important;
  }
  .introtext {
    padding-top: 2em !important;
    padding-bottom: 2em !important;
  }
  .btn-stylized {
    font-size: 0.8rem !important;
  }
}

/* Mobile */
@media (max-width: 768px) {
  .site-header {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding: 12px 15px;
  }
  .logo-link {
    flex: none;
    display: block;
  }
  .site-logo {
    width: 180px !important;
  }
  .insta-header {
    position: static !important;
    transform: none !important;
  }
  .insta-header-logo {
    width: 80px;
  }
  .art-header {
    display: none;
  }
  .hero-section {
    min-height: 30vh;
  }
  .introtext h2.titreintro {
    font-size: 3.5rem !important;
  }
  .introtext {
    padding-top: 1.5em !important;
    padding-bottom: 1.5em !important;
  }
  .introtext .col-md-6 {
    font-size: 0.85em;
  }
  .btn-stylized2 {
    font-size: 16px;
  }
  .footer {
    padding: 30px 0 15px;
  }
  .footer-title {
    font-size: 2.5em !important;
  }
  .art-footer-left {
    width: 200px;
  }
  .art-footer-right {
    width: 150px;
  }
}

/* Petit mobile */
@media (max-width: 480px) {
  .site-logo {
    width: 150px !important;
  }
  .insta-header-logo {
    width: 65px;
  }
  .introtext h2.titreintro {
    font-size: 2.8rem !important;
  }
  .hero-section {
    min-height: 25vh;
  }
  .footer-title {
    font-size: 1.8em !important;
  }
  .footer-link {
    font-size: 0.75em;
  }
}

@font-face {
    font-family: 'Adventures Unlimited';
    src: local('Adventures Unlimited Script Bold'), local('Adventures-Unlimited-Script-Bold'),
        url('./assets/fonts/AdventuresUnlimited-ScriptBold.woff2') format('woff2'),
        url('./assets/fonts/AdventuresUnlimited-ScriptBold.woff') format('woff'),
        url('./assets/fonts/AdventuresUnlimited-ScriptBold.ttf') format('truetype');
    font-weight: 700;
    font-style: normal;
  }

@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,100..900;1,100..900&display=swap');

#app{
  font-family: 'Montserrat';
  font-size: 1em;
  background-color: #eded87;
  position: relative;
  overflow: hidden;
}

/* Art décoratif header */
.art-header {
  position: absolute;
  left: -100px;
  top: -150px;
  width: 900px;
  pointer-events: none;
  z-index: 0;
  opacity: 0.7;
}

/* Header avec logo */
.site-header {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 30px 20px 20px;
  position: relative;
  z-index: 10;
  overflow: hidden;
}
.logo-link {
  flex: 1;
  display: flex;
  justify-content: center;
}
.site-logo {
  width: 500px;
  height: auto;
  filter: drop-shadow(0 4px 8px rgba(0,0,0,0.2));
  display: block;
}
.insta-header {
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
}
.insta-header-logo {
  width: 200px;
  height: auto;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.15));
  transition: transform 0.2s ease;
  display: block;
}
.insta-header-logo:hover {
  transform: scale(1.05);
}

.container {
  max-width: 1200px;
}

a{
  text-decoration: none !important;
  color: #1b3345 !important;
}

.neonText {
  color: #1b3345;
  font-family: 'Adventures Unlimited', cursive;
  cursor: pointer;
  width: fit-content;
}
.neonText:hover {
  color: #fff;
  text-shadow:
    0 0 2px #fff,
    0 0 10px #fff,
    0 0 21px #fff,
    0 0 42px #f387a2,
    0 0 82px #f387a2,
    0 0 92px #f387a2,
    0 0 102px #f387a2,
    0 0 151px #f387a2;
}

/* Styles pour l'effet de survol sur les images */
.image-container {
  position: relative;
  overflow: hidden;
  border-radius: 1em;
  cursor: pointer;
  transition: 0.3s ease;
}

.img-fluid {
  width: 100%;
  height: auto;
  transition: 0.3s ease;
}

.image-container:hover .img-fluid {
  transform: scale(1.05);
}

.overlay {
  transition: 0.5s ease;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  opacity: 1;
  justify-content: center;
  padding: 2em !important;
}

/* .image-container:hover .overlay {
  opacity: 0;
} */

.text {
  text-align: left;
  transition: opacity 0.5s ease;
  opacity: 1;
  color: black;
  font-size: 1em;
  line-height: 1.4em;
}

.text h4{
  text-transform: uppercase;
  font-weight: bold;
  color: white;
  margin-bottom: 0.5em;
  font-size: 2em;
}

.text .content{
  text-align: justify !important;
}

.image-container:hover .text {
  opacity: 1;
}

.footer {
  background-color: #1b3345;
  color: #fff;
  padding: 40px 0 20px;
  font-size: 0.8em;
  position: relative;
  overflow: hidden;
}
.footer-content {
  position: relative;
  z-index: 2;
}
.art-footer {
  position: absolute;
  pointer-events: none;
  z-index: 1;
  opacity: 0.15;
}
.art-footer-left {
  left: -60px;
  bottom: -80px;
  width: 300px;
  transform: scaleX(-1);
}
.art-footer-right {
  right: -60px;
  bottom: -80px;
  width: 220px;
}

.footer-title {
  color: white;
  font-size: 4em;
}
.footer a {
  color: #eded87 !important;
  text-decoration: none;
  transition: all 0.3s ease;
}

.footer a:hover {
  color: #f387a2;
}

.btn-stylized {
  margin-top: 2em;
  background-color: transparent; /* Fond transparent */
  color: white !important; /* Texte blanc */
  border: 2px solid white; /* Bordure blanche */
  border-radius: 30px; /* Bords arrondis */
  padding: 10px 20px; /* Padding intérieur */
  font-size: 16px; /* Taille du texte */
  font-weight: bold; /* Texte en gras */
  text-transform: uppercase; /* Texte en majuscules */
  cursor: pointer; /* Curseur en forme de main */
  transition: all 0.3s ease; /* Transition douce pour les effets de survol */
  text-decoration: none; /* Pas de soulignement du texte */
  display: inline-block; /* Permet au bouton de s'ajuster au contenu */
}

.btn-stylized2 {
  margin-top: 2em;
  background-color: transparent;
  color: #1b3345 !important;
  border: 2px solid #1b3345;
  border-radius: 30px;
  padding: 10px 20px;
  font-size: 20px;
  font-weight: bold;
  text-transform: uppercase;
  cursor: pointer;
  transition: all 0.3s ease;
  text-decoration: none;
  display: inline-block;
}


.btn-stylized2:hover, .btn-stylized2:focus {
  background-color: #1b3345;
  color: #eded87 !important;
  text-decoration: none;
}

/* Ajustements pour accessibilité et focus visuel */
.btn-stylized2:focus-visible {
  outline: 3px solid #44bfb1;
  outline-offset: 3px;
}

.img-icon-hover{
  position: absolute;
  width:100%;
  padding: 35%;
  align-items: center;
  transition: all 0.3s ease;
}

.btn-stylized:hover, .btn-stylized:focus {
  background-color: #eded87;
  color: #1b3345 !important;
  text-decoration: none;
}

/* Ajustements pour accessibilité et focus visuel */
.btn-stylized:focus-visible {
  outline: 3px solid #44bfb1;
  outline-offset: 3px;
}

.hero-section {
  background-image: url('@/assets/gallery/23.jpg');
  background-size: cover;
  background-position: top;
  min-height: 40vh;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
  color: white;
  margin-bottom: 2em;
}

.hero-img2 {
  background-image: url('@/assets/gallery/7.jpg') !important;
  background-position: center;
  border-radius: 0;
}

.hero-section::after {
  content: '';
  background: rgba(0, 0, 0, 0.4); /* Overlay sombre pour une meilleure lecture du texte */
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}

.hero-img2::after {
border-radius: 0;
}

.hero-img4 {
  background-image: url('@/assets/gallery/lamaison.jpg') !important;
  border-radius: 0;
  background-position: center;
}

.hero-img4::after {
border-radius: 0;
}

.herotitre{
  font-family: 'Adventures Unlimited', cursive;
  font-size: 9em !important;
}

.container {
  position: relative;
  z-index: 2;
}
.introtext{
  padding-top: 5em;
  padding-bottom: 6em;
}
.introtext h2{
  font-family: 'Adventures Unlimited', cursive;
  font-size: 7em !important;
}
.introtext .col-6{
  text-align: justify;
}
.v-enter-active,
.v-leave-active {
  transition: opacity 0.5s ease;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}
.tile {
  position: relative;
  border-radius: 1em;
  overflow: hidden;
  background-color: rgba(255,255,255,0.95);
  transition: transform 0.3s, box-shadow 0.3s;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  box-shadow: 0 4px 16px rgba(27,51,69,0.12);
}
.tile:hover {
  transform: scale(1.03);
  box-shadow: 0 8px 24px rgba(27,51,69,0.2);
}
.tile img {
  width: 100%;
  height: auto;
  max-height: 300px;
  object-fit: cover;
}
.tile-text {
  padding: 1em !important;
  text-align: center;
}
.tile-icon {
  width: 4em !important;
  margin-bottom: 1em;
}
.tile h4 {
  font-size: 1.5em !important;
  margin-bottom: 0.5em !important;
  color: white !important;
  font-weight: bold;
  text-transform: uppercase;
}
.tile .content {
  font-size: 0.9em;
  text-align: justify !important;
}


@media print {
  @page { size: A3 portrait; margin: 0; }
  body { margin: 0 !important; padding: 0 !important; overflow: hidden !important; background-color: #eded87 !important; }
  html { overflow: hidden !important; background-color: #eded87 !important; height: 100% !important; }
  .site-header, .footer, footer, .no-print, .art-global {
    display: none !important;
  }
  #app {
    overflow: visible !important;
  }
  * {
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}

</style>
